import { useIconFilter } from "./components/filter";


$(() => {
  useIconFilter()
})